var render = function render(){var _vm=this,_c=_vm._self._c;return _c('template-base',[_c('h1',[_vm._v("Página não encontrada")]),_c('section',[_c('AlertOctagonIcon',{staticClass:"text-dark",attrs:{"size":"10x"}})],1),_c('div',{staticClass:"text-right mt-4"},[_c('router-link',{staticClass:"btn btn-success text-white lg",attrs:{"to":{ name: 'home' }}},[_vm._v("Ir para a página inicial")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }